import axios from "axios";
import moment from "moment";
import {
  API_URL, API_URL_ESV, API_URL_SQL, API_URL_ANGULAR, automatedServerRoute,
} from "../utils/Constant";
import { getUser } from "../utils/helpers";

// Get ready reports
export const getReadyReports = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/getwosbatchreports/?date=&category=ready`,
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    console.log("error from getBatchReports()");
    return { success: false, message: "Something went wrong" };
  }
};

// Send the ready reports
export const sendBatchReports = async (payload, date) => {
  try {
    let response = await axios.post(`${API_URL}/generatebatchreports/`, {
      date,
      is_partial: "False",
      list: payload,
      disableRunQc: false,
      skipS3Logging: true,
    });

    let data = await response.data;
    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong. ";
    return { success: false, message };
  }
};

// check ready results and send reports
export const checkReadyReports = async () => {
  const date = moment(new Date()).format("MM/DD/YYYY");
  const resReady = await getReadyReports();
  if (resReady && resReady.success && resReady.list.length > 0) {
    sendBatchReports(resReady.list, date);
  }
};

// Get ready reports
export const getReadySendReports = async (params, signal = null) => {
  try {
    const response = await axios.get(
      `${API_URL}/getreports/`,
      { params, signal },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    console.log("error from getReadySendReports()");
    return { success: false, message: "Something went wrong", canceled: e.code === "ERR_CANCELED" };
  }
};

// get samples data for one work order
export const getData = async (payload) => {
  try {
    // uncomment
    // let response = await axios.get(`${API_URL}/getwodata_test/`, {
    const response = await axios.get(`${API_URL}/getwodata/`, {
      params: {
        wo: payload.wo || "",
        report_id: payload.reportID || "",
      },
    });
    const data = await response.data;
    const res = { samples: [], ctg: "" };
    if (data && data.length > 0) {
      const result = data[0].result;
      if (result && result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          // change the date format for the post request
          if (result[i].report_date.includes("/")) {
            // const reportDateArr = result[i].report_date.split("/");
            // const formattedReportDate =
            //   reportDateArr[2] +
            //   "-" +
            //   reportDateArr[0] +
            //   "-" +
            //   reportDateArr[1] +
            //   " 0:0";
            // result[i].report_date = formattedReportDate;
            result[i].report_date = `${moment(Date.now()).format("YYYY-MM-DD")} 0:0`;
          } else {
            // result[i].report_date = result[i].report_date + " 0:0";
            result[i].report_date = `${moment(Date.now()).format("YYYY-MM-DD")} 0:0`;
          }
          if (result[i].received_date.includes("/")) {
            const receivedDateArr = result[i].received_date.split("/");
            const formattedReceivedDate = `${receivedDateArr[2]}-${receivedDateArr[0]}-${receivedDateArr[1]} 0:0`;
            result[i].received_date = formattedReceivedDate;
          } else {
            result[i].received_date = `${result[i].received_date} 0:0`;
          }
        }
        res.samples = result;
      }
    }

    return { success: true, ...res };
  } catch (e) {
    console.log("error from getData", e);
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

// post request to save the sample and report path to DB
export const saveData = async (payload) => {
  try {
    let response;
    if (payload.ctg === "env") {
      response = await axios.post(
        `${API_URL_ESV}/environment_report/`,
        payload.data,
      );
    } if (payload.ctg === "product") {
      response = await axios.post(
        `${API_URL_ESV}/product_report/`,
        payload.data,
      );
    }
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    console.log("error from saveData", e);
    // getViewAsPerStatusCode(e);
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

// email
export const sendS3UrlGrouped = async (payload) => {
  const params = {
    title: "send",
    list: payload,
  };
  try {
    const response = await axios.post(`${API_URL}/sendreports/`, params);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false };
  }
};

export const moveFilesToHistory = async (payload, category) => {
  try {
    const user = getUser();
    const isServerSend = window.location.href.includes(automatedServerRoute);
    let response = await axios.post(`${API_URL}/updatereports/`, {
      category,
      report_list: payload,
      user_email: isServerSend ? "reports_bot@genistabio.com" : user.email,
      user_id: isServerSend ? 190 : user.id,
    });
    let data = await response.data;
    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong. ";
    return { success: false, message };
  }
};

/**
 * Update a report send status: "Approved" or "Not Approved"
 * @param {*} payload
 * @returns
 */
export const updateReportsSendStatus = async (payload) => {
  try {
    const response = await axios.patch(
      `${API_URL}/updatereports/`,
      payload,
    );
    const data = response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message || "Something went wrong";
    return { success: false, message };
  }
};

export const moveFiles = async (payload) => {
  try {
    const user = getUser();
    const { report_id_list, category, new_category } = payload;
    let response = await axios.post(`${API_URL}/movereports/`, {
      report_id_list,
      category,
      new_category,
      user_email: user.email,
    });
    let data = await response.data;
    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong. ";
    return { success: false, message };
  }
};

export const deleteFiles = async (payload) => {
  const user = getUser();
  try {
    let response = await axios.post(`${API_URL}/deletereports/`, {
      report_id_list: payload,
      user_email: user.email,
    });
    let data = await response.data;
    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong. ";
    return { success: false, message };
  }
};

export const runQCApi = async () => {
  try {
    const response = await axios.get(`${API_URL}/qcreports/`);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    console.log("error from RunQCApi()");
    return { success: false, message: "Something went wrong" };
  }
};

export const runSqlQCApi = async (disableInterceptor = false) => {
  try {
    const response = await axios.get(`${API_URL_SQL}/qcreports/`, {
      params: {
        disableInterceptor,
      },
    });
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    console.log("error from RunQCApi()");
    return { success: false, message: "Something went wrong" };
  }
};

export const runQCApiPost = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/qcreports/`, payload);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    console.log("error from RunQCApi()");
    return { success: false, message: "Something went wrong" };
  }
};

export const getPesticideReportData = async (signal = null) => {
  try {
    const response = await axios.get(`${API_URL}/getpesticidessamples/`, { signal });
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message, canceled: e.code === "ERR_CANCELED" };
  }
};

export const getPesticideMrlData = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/pesticidemrldata/`, payload);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

export const updatePesticideMRLData = async (payload) => {
  try {
    const user = getUser();
    const response = await axios.post(
      `${API_URL}/updatepesticidemrldata/`,
      { ...payload, user_email: user.email },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong";
    return { success: false, message };
  }
};

export const getPesticideCustomerData = async (search = "", signal = null) => {
  try {
    const response = await axios.get(
      `${API_URL}/pesticidescustomercountries/`,
      { params: { search }, signal },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message, canceled: e.code === "ERR_CANCELED" };
  }
};

export const updatePesticideCountries = async (payload) => {
  try {
    const response = await axios.post(
      `${API_URL}/pesticidescustomercountries/`,
      payload,
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e.response.data.message || "Something went wrong";
    return { success: false, message };
  }
};

/**
 *
 * @param {*} payload
 * {
 * GenistaID,
 * Analysis,
 * Result,
 * OrderID,
 * action: "Submit" | "Save"
 * overwrite_complete: boolean, when = true, it will allow to update test result on a completed status test }
 * source: "APP_NAME - TAB_NAME - SUB_TAB_NAME", for example: "Automation - Chemistry - Pending"
  }
 * @returns {*} { message, new_status, result_date: "YYYY-MM-DD", updated_micro_hierarchy_failed_tests: [{ internal, display, result, tis_id, ...}]}
 */
// this update result api uses display name
export const updateTestResult = async (payload) => {
  try {
    const params = {
      ...payload,
      user_id: getUser().id,
      action: payload.action ?? "Submit",
      overwrite_complete: payload.overwrite_complete ?? false,
    };
    const response = await axios.get(
      `${API_URL}/updateresultautomation/`,
      { params },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Something went wrong.";
    return { success: false, message };
  }
};

export const approveRejectSampleQC = async (payload) => {
  try {
    const response = await axios.post(
      `${API_URL}/mlqccorrection/`,
      payload,
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e.response?.data?.message || "Something went wrong";
    return { success: false, message };
  }
};

/**
 * We use this api call to get the user's list for QC dropdowns.
 * @returns basic list of users from angular api
 */
export const getUserList = async () => {
  try {
    const response = await axios.get(
      `${API_URL_ANGULAR}/users/?is_active=true&role=&page=1&page_size=10000&search= `,
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: e.response?.data?.detail || "Something went wrong." };
  }
};

/**
 * Post send reports using new api
 * @param {Number} user_id user id
 * @param {{report_id: string, report_type: string}[]} reports reports objects array
 * @param {string} tab current tab
 * @param {boolean} autosend whether to send reports automatically
 */
export const sendReportServer = async (user_id, reports, tab, autosend = false, frontend_log_data = null) => {
  const params = {
    user_id,
    reports,
    source: tab,
    frontend_log_data,
  };
  if (autosend) {
    params.autosend = true;
    delete params.reports;
  }
  try {
    const response = await axios.post(`${API_URL}/send_report_server/`, params);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const errorData = e.response?.data || {};
    return { success: false, ...errorData, message: e.response.data.message || "Something went wrong." };
  }
};

/**
 * Fetch the sample information for a given report id pk
 * @param {*} params { report_id_pk: number}
 * @returns {Object} { success: Boolean, result: { sample_info: {}[], report_id, workorder_id }, message}
 */
export const getReportSamplesInfo = async (params, signal = null) => {
  try {
    const response = await axios.get(`${API_URL}/getreportspdf/`, { params, signal });
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", canceled: e.code === "ERR_CANCELED" };
  }
};
